import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';
import { toChartData, formatMoney, formatDay } from '../utils/competitorSeries';

// Una línea escalonada por tienda y otra, más gruesa, de Enigma. Punteado = la tienda no tenía
// stock; más claro = historia importada del comparador (anterior a nuestras lecturas).
const CompetitorPriceChart = ({ series }) => {
    const { data, lines } = toChartData(series);
    if (data.length === 0) {
        return <div className="text-muted" style={{ padding: '24px 0', textAlign: 'center' }}>Todavía no hay historia para dibujar.</div>;
    }

    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eceeef" />
                <XAxis
                    dataKey="t"
                    type="number"
                    scale="time"
                    domain={['dataMin', 'dataMax']}
                    tickFormatter={formatDay}
                    tick={{ fontSize: 11 }}
                />
                <YAxis tickFormatter={formatMoney} tick={{ fontSize: 11 }} width={64} domain={['auto', 'auto']} />
                <Tooltip labelFormatter={formatDay} formatter={(value) => formatMoney(value)} />
                <Legend />
                {lines.map((line) => (
                    <Line
                        key={line.key}
                        dataKey={line.key}
                        name={line.legend ? line.label : line.name}
                        type="stepAfter"
                        stroke={line.color}
                        strokeWidth={line.isOwn ? 3 : 1.5}
                        strokeDasharray={line.style === 'out' ? '4 4' : undefined}
                        strokeOpacity={line.style === 'imp' ? 0.45 : 1}
                        legendType={line.legend ? 'line' : 'none'}
                        dot={false}
                        connectNulls={false}
                        isAnimationActive={false}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
};

export default CompetitorPriceChart;
